import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import { CurrentTemplate } from "../../Configuration/SalaryRevise/CurrentTemplate";
import { showToast } from "services/utils/Status";
import { customGetAPI } from "services/utils/CustomAPI";
import { themes } from "services/constants";
import { CustomTextBox } from "components/CustomComponents";

export const SalaryRevisionHistory = ({
  showSalaryRevisionHistory,
  setShowSalaryRevisionHistory,
  getRevisionData,
}) => {
  const { domain } = useSelector((state) => state.tokenReducer);
  const [currentTemplateData, setCurrentTemplateData] = useState([]);
  const [newTemplateData, setNewTemplateData] = useState([]);
  const [trigger, setTrigger] = useState(true);

  const handleCancelClose = () => {
    setShowSalaryRevisionHistory(false);
  };

  useEffect(() => {
    const getEditData = async () => {
      const res = await customGetAPI(
        `${domain}hrzone/salary/salary_revision/salary-revision/?revision_id=${getRevisionData?.revision_id}`,
      );
      if (res.ok) {
        setCurrentTemplateData(res?.responseDetails?.previous_salary);
        setNewTemplateData(res?.responseDetails?.new_salary);
        setTrigger(false);
      } else {
        showToast("error", res?.message);
      }
    };
    if (trigger && getRevisionData) {
      getEditData();
    }
  }, [domain, getRevisionData, trigger]);

  return (
    <React.Fragment>
      <ConfirmationDialog
        open={showSalaryRevisionHistory}
        onClose={handleCancelClose}
        title={"Salary Revision"}
        showChildren={true}
        defaultWidth={1600}
        hideButton={true}
      >
        <Box sx={{ mb: 3 }}></Box>
        <Box
          sx={{
            display: "flex",
            gap: 4,
            mt: 2,
            flexDirection: { xs: "column", md: "row" },
            mb: 3,
            pointerEvents: "none",
            opacity: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600} mb={0.5}>
              Current Template
            </Typography>
            <CustomTextBox selectedValue={currentTemplateData?.template_name} />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600} mb={0.5}>
              Effective From
            </Typography>
            <CustomTextBox
              selectedValue={
                currentTemplateData?.effective_from
                  ? currentTemplateData?.effective_from
                      .split("-")
                      .reverse()
                      .join("-")
                  : null
              }
            />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600} mb={0.5}>
              New Template
            </Typography>
            <CustomTextBox selectedValue={newTemplateData?.template_name} />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600} mb={0.5}>
              Effective From
            </Typography>
            <CustomTextBox
              selectedValue={
                newTemplateData?.effective_from
                  ? newTemplateData?.effective_from
                      .split("-")
                      .reverse()
                      .join("-")
                  : null
              }
            />
          </Box>
        </Box>

        <Box>
          <Mui.Divider />
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 3,
            mt: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            sx={{
              flex: 1,
              border: `1px solid ${themes?.redColor}`,
              backgroundColor: "#f8f9fa",
              borderRadius: 2,
            }}
          >
            <CurrentTemplate
              currentTemplateData={currentTemplateData}
              isHistoryScreen={true}
            />
          </Box>

          <Box
            sx={{
              flex: 1,
              border: `1px solid ${themes?.greenColor}`,
              borderRadius: 2,
            }}
          >
            <CurrentTemplate
              currentTemplateData={newTemplateData}
              isHistoryScreen={true}
            />
          </Box>
        </Box>
      </ConfirmationDialog>
    </React.Fragment>
  );
};
